import { h } from 'vue';

import { Text } from '@/utils';

export default {
    props:
    {
        // determines if clicks on the background
        // the modal will close
        backDropClose:
        {
            type: Boolean,
            default: true,
        },

        // determines if the close button on the top right
        // will show or not
        closeButton:
        {
            type: Boolean,
            default: true,
        },

        // determines if the escape button on the keyboard
        // can close the offcanvas when pressed
        escapeClose:
        {
            type: Boolean,
            default: true,
        },

        // determines if the offcanvas
        // will show on right
        isFlip:
        {
            type: Boolean,
            default: true,
        },

        // determines if the offcanvas
        // will show as full page
        isFull:
        {
            type: Boolean,
            default: false,
        },

        // determines if the offcanvas
        // show or hide
        isOpen:
        {
            type: Boolean,
            default: false,
            required: true,
        },

        // determines if the offcanvas
        // have backdrop
        isOverlay:
        {
            type: Boolean,
            default: true,
        },

        // determines the type of transition
        // of the offcanvas
        transition:
        {
            type: String,
            default: 'slide', // 'none', 'slide', 'push'
        },
    },

    data()
    {
        return {
            openClass: '',
            displayClass: '',
        };
    },

    methods:
    {
        backDropEvent()
        {
            if (this.$refs.offcanvas === event.target)
            {
                this.close();
            }
        },

        escapeEvent()
        {
            if (event.keyCode === 27)
            {
                this.close();
            }
        },

        close()
        {
            this.$emit('closeOffcanvas', false);
        },

        toggleScrollbar(bool)
        {
            const el = document.body;

            if (bool)
            {
                el.classList.add('vh-offcanvas-page');
            }

            else
            {
                setTimeout(() =>
                {
                    el.classList.remove('vh-offcanvas-page');
                }, 300);
            }
        },

        toggleOffcanvas(bool)
        {
            if (bool)
            {
                this.displayClass = 'vh-offcanvas-block';

                setTimeout(() =>
                {
                    this.openClass = 'vh-open';
                }, 100);
            }

            else
            {
                this.openClass = '';

                setTimeout(() =>
                {
                    this.displayClass = '';
                }, 300);
            }
        },

        handleContainer(bool)
        {
            const el = document.body;

            if (bool && this.transition === 'push')
            {
                if (this.isFlip)
                {
                    el.classList.add('vh-offcanvas-flip');
                }

                el.classList.add('vh-offcanvas-container');

                setTimeout(() =>
                {
                    el.classList.add('vh-offcanvas-container-animation');
                }, 100);
            }

            else if (!bool && this.transition === 'push')
            {
                el.classList.remove('vh-offcanvas-container-animation');

                setTimeout(() =>
                {
                    if (this.isFlip)
                    {
                        el.classList.remove('vh-offcanvas-flip');
                    }

                    el.classList.remove('vh-offcanvas-container');
                }, 300);
            }
        },
    },

    computed:
    {
        handleTransitionClass()
        {
            switch (this.transition)
            {
                case 'none':
                    return 'vh-offcanvas-none';

                case 'slide':
                    return 'vh-offcanvas-slide vh-offcanvas-bar-animation';

                case 'push':
                    return 'vh-offcanvas-push vh-offcanvas-bar-animation';

                default:
                    break;
            }

            return null;
        },
    },

    watch:
    {
        isOpen()
        {
            if (this.isOpen)
            {
                if (this.escapeClose)
                {
                    window.addEventListener('keyup', this.escapeEvent);
                }

                if (this.backDropClose)
                {
                    this.$refs.offcanvas.addEventListener('click', this.backDropEvent);
                }

                this.toggleScrollbar(true);
                this.toggleOffcanvas(true);
                this.handleContainer(true);
            }

            else
            {
                if (this.escapeClose)
                {
                    window.removeEventListener('keyup', this.escapeEvent);
                }

                if (this.backDropClose)
                {
                    this.$refs.offcanvas.removeEventListener('click', this.backDropEvent);
                }

                this.toggleScrollbar(false);
                this.toggleOffcanvas(false);
                this.handleContainer(false);
            }
        },
    },

    render()
    {
        return h(
            'div',
            {
                class: Text.joinClass(
                    'vh-offcanvas',
                    this.isOverlay && 'vh-offcanvas-overlay',
                    this.isFlip && 'vh-offcanvas-flip',
                    this.openClass,
                    this.displayClass
                ),

                ref: 'offcanvas',
            },
            [
                h(
                    'div',
                    {
                        class: Text.joinClass(
                            'vh-offcanvas-bar',
                            this.handleTransitionClass,
                            this.isFull && 'vh-offcanvas-bar-full'
                        ),
                    },

                    [
                        this.$slots.default(),
                        
                        this.closeButton && h(
                            'a',
                            {
                                class: Text.joinClass(
                                    'vh-offcanvas-close',
                                    'vh-close',
                                    'vh-link-reset'
                                ),
                                
                                onClick: () => this.close(),
                            },

                            [
                                h(
                                    'i',
                                    {
                                        class: 'fa fa-times',
                                    }
                                ),
                            ]
                        ),
                    ]
                ),
            ]
        );
    },
};
